import { render, staticRenderFns } from "./EditorToolbar.vue?vue&type=template&id=1d922ebb&"
import script from "./EditorToolbar.vue?vue&type=script&lang=ts&"
export * from "./EditorToolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports